import React, { createContext, useContext, useState } from 'react';

import AlertMessage from '../components/Atoms/AlertMessage/AlertMessage';
import AlertMessageModel, { Severity } from '../models/AlertMessage';

interface AlertContextType {
  setAlert: (alert: AlertMessageModel) => void;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [alert, setAlertState] = useState<AlertMessageModel>({
    open: false,
    message: '',
    translate: false,
    severity: Severity.INFO,
  });

  const setAlert = (newAlert: AlertMessageModel) => {
    setAlertState({ ...newAlert, open: true });
  };

  return (
    <AlertContext.Provider value={{ setAlert }}>
      <AlertMessage
        alertBody={alert}
        setOpen={(open) => setAlertState((prev) => ({ ...prev, open }))}
      />
      {children}
    </AlertContext.Provider>
  );
};

export const useGlobalAlert = (): AlertContextType => {
  const context = useContext(AlertContext);
  if (!context)
    throw new Error('useGlobalAlert must be used within AlertProvider');
  return context;
};
